import { observable, toJS } from "mobx";
import ServicosService from "../services/ServicosService";
import { createPDFDetalhesCalculadora } from "../Utils/pdfDetalhesCalculadora";
import { isEmail } from "../../../utils/validadores";

export default class SimulacaoServicosEmailStore {

    @observable pdfEmail;

    setPdfEmail = (data) => {
        this.pdfEmail = data;
    }

    setDataPdf = async (dadosModalidade) => {
        await createPDFDetalhesCalculadora(dadosModalidade, 'Email', this.setPdfEmail);
    }

    enviarEmailSimulacao = async (strEmails) => {

        if (!strEmails) return { error: 'Nenhum e-mail inserido!'};

        let emailsError;

        const emails = strEmails.split(/[;,|\/ ]/gm);
    
        const allValid = emails.every(isEmail);
        
        emailsError = allValid ? "" : "E-mail(s) inválidos.";

        if (emailsError) return { error: emailsError};
        
        // return { error: ''}

        try {
            const file = new File([this.pdfEmail], `Calculadora.pdf`,{ type: "octet/stream;charset=UTF-8" });                    

            const formData = new FormData();

            formData.append('CalculadoraPdf', file, file.name);            
            formData.append("Notifier",  JSON.stringify( { Email: emails.join(";") }));
    
            const { status, data } = await ServicosService.enviarEmailSimulacao(formData);
    
            if (status != 200) return { error: 'Erro ao tentar enviar e-mails!'};

            return { error: ''}
    
        } catch (error) {
          console.log(error)
          return { error };
        }
    }

    carregarCalculadoraResumo = async (dadosModalidade) => {
        try {            

            createPDFDetalhesCalculadora(dadosModalidade);
            
            return { data: true };

        } catch (error) {
            console.log(error)
            let message = error.Message || "Ocorreu um erro ao tentar gerar o resumo.";
            this.setError(this, message);
            return { error: message }
        } 
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/stores/SimulacaoServicosEmailStore.js